// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1Lfj0","signatureButtonsRight":"ModalSign_signatureButtonsRight__3p2c4"};